import { CircularProgress, TextField as MuiTextField, TextFieldProps as MuiTextFieldProps } from "@mui/material";
import { Field, getIn } from 'formik';
import React from "react";
import FilterWrapper from "./FilterWrapper";


const TextField = (props: TextFieldProps) => {

    return (
        <Field name={ props.name }>
            { ({ form: { errors }, field }) => {
                const error = getIn(errors, field?.name || '-');

                return (
                    <TextInput
                        id={ props.name }
                        { ...field }
                        { ...props }
                        error={ error }
                    />
                )
            } }
        </Field>
    );
}
export default TextField;

export const TextInput = (props: TextInputProps) => {
    return (
        <MuiTextField
            fullWidth
            label={ props.label }
            placeholder={ props.placeholder }
            error={ !!props.error }
            disabled={ props.isLoading }
            { ...props }
            helperText={
                <>
                    { props.error }
                    { props.error && props.helperText && <br/> }
                    { props.helperText }
                </>
            }
            InputProps={ {
                endAdornment: props.isLoading ? <CircularProgress size={ 20 }/> : undefined,
                ...props.InputProps
            } }
        />
    );
}

export const TextFilter = (props: TextInputProps) => {
    const used = !!props.value && props.value !== 0;

    return (
        <FilterWrapper used={ used }>
            <TextInput { ...props } />
        </FilterWrapper>
    );
}

export type TextFieldProps = Omit<TextInputProps, 'name'> & {
    readonly name: string
}

type TextInputProps = MuiTextFieldProps & {
    readonly isLoading?: boolean
}